import React, { useState } from 'react';
import moment from 'moment';
import { CompositeView, CrudContext, CrudMasterDetailView, GridView, SimpleView, notification } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import AbaControleQaqc from './Controle';
import { CreateControleQaqc, getAllControleQaqc } from '@app/api/controleQaqc';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import AbaHistorico from './Historico';
import CreateControleQualidadeForm from './CreateControleQualidadeForm';
import { ContratoControleQAQC, GetContratoWithBM } from '@app/api/contrato';

const ControleQaqc = () => {
  const [update, setUpdate] = useState(false);
  const [medicaoId, setMedicaoId] = useState<string | undefined>();
  const [numeroContrato, setNumeroContrato] = useState();
  const [contrato, setContrato] = useState<ContratoControleQAQC | undefined>();

  const [GetAllItems] = useState(() => {
    return getAllControleQaqc;
  });


  const onSearchContrato = async () => {
    setMedicaoId(undefined);
    if(numeroContrato){
      const resp: any = await GetContratoWithBM(numeroContrato);
      if(resp)
        setContrato(resp);
    }
  }

  const onUpdate = () => {
    setUpdate(!update);
  };

  const CreateControleQualidade = async (e: any) => {
    if(!medicaoId){
      notification.warn('Selecione uma Medição Válida.');
    }else{
      const resp: any = await CreateControleQaqc({
        MedicaoId: medicaoId
      });
  
      if(resp){
        setMedicaoId(undefined);
        if(numeroContrato){
          const resp: any = await GetContratoWithBM(numeroContrato);
          if(resp)
            setContrato(resp);
        }
      }
    }
  }

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['SGC_CADASTRAR_CONTROLE_QUALIDADE']) ? CreateControleQualidade : undefined}
      titleExtractor={item => `${item.numeroContrato} - BM ${item.numeroBm}  ${item.identificadorPQ ? " - " + item.identificadorPQ: ""} ${item.escopo ? " - " + item.escopo : ""} - ${item.fornecedor}`}
      icon="printing-ruler"
      filterPredicate={(item, value) =>
        item.numeroBm.toString().startsWith(value) ||
        item.numeroContrato
          .toString()
          .toLowerCase()
          .startsWith(value) ||
        item.fornecedor.toString().startsWith(value)
      }
      descriptionExtractor={item =>
        'De: ' + moment(item.periodoInicio).format(dateFormat) + ' Até: ' + moment(item.periodoFim).format(dateFormat)
      }>
      <CrudContext.Consumer>
        {({ selectedItem }) => {
          return (
            <>
              {selectedItem && hasPermission(['MEDICAO_CONTROLE_QAQC_VISUALIZAR']) ? (
                <CompositeView>
                  <GridView icon="commons-document" id="controleQaqc" noform title="Controle de Qualidade">
                    <AbaControleQaqc id={selectedItem.id} update={update} onUpdate={onUpdate} />
                  </GridView>
                  <GridView icon="commons-document" id="historico" noform title="Histórico">
                    <AbaHistorico id={selectedItem.id} update={update} />
                  </GridView>
                </CompositeView>
              ) : (
                <CompositeView>
                  <GridView noform>
                    <CreateControleQualidadeForm 
                        medicaoId={medicaoId}
                        setMedicaoId={setMedicaoId}
                        numeroContrato={numeroContrato}
                        setNumeroContrato={setNumeroContrato}
                        contrato={contrato}
                        setContrato={setContrato}
                        onSearchContrato={onSearchContrato}              />
                  </GridView>
                </CompositeView>
              )}
            </>
          );
        }}
      </CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default ControleQaqc;
